export const getValidationMessage = (errors: ReadonlyArray<string>): string => {
  const prettyErrors = errors.map(error => `❗ ${error}`).join('\n\n')
  const message = 'Failed to decode response body'
  return `${message}\n${prettyErrors}`
}
